import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
Vue.use(Router)
const router = new Router({
  routes: [
    {
      path: '/',
      component: () => import('@/pages/main/index'),
      redirect: 'home',
      children: [
        {
          path: 'home',
          component: () => import('@/pages/main/components/home'),
          name: 'home',
        },
      ]
    },
    {
      path: '/404',
      component: () => import('@/components/errorPage/404')
    },
    // 输入其他地址跳转到登录页
    {
      path: '*',
      redirect: '/'
    }
  ]
})

router.beforeEach(function (to, from, next) {
  var userInfo = store.state.userInfo;
  console.log("beforeEach")
  if (userInfo == null || userInfo.username == undefined) {
    var path = to.path;
    // 特定路径进入 登录页面
    if (path.indexOf('/usercenter') != -1) {
      return next('/register')
    }
  }
  next()
})
export default router


// WEBPACK FOOTER //
// ./src/router/index.js